import React from 'react'
import { Container } from 'react-bootstrap'
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';

const CustomizeYourPreOwnedRolex = () => {
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails.title}</title>
        <meta name="description" content={metaDetails.description}></meta>
        <meta name="keywords" content={metaDetails.keywords}></meta>
      </Helmet>
      <Container className='mt-4'>
        <h2 className='font-weight-bold text-center mb-3'>Custom Accessories</h2>
        <iframe title='Custom Accessories' width="100%" height="1400px" src="https://www.tdcmicrosite.com" className="framebg"></iframe>
      </Container>
    </>

  )
}

export default CustomizeYourPreOwnedRolex